// extracted by mini-css-extract-plugin
export var cardImageContainer = "productCard-module--cardImageContainer--98db8";
export var emailMarketingHoverImg = "productCard-module--emailMarketingHoverImg--28f37";
export var hoverContainer = "productCard-module--hoverContainer--12385";
export var imageContainer = "productCard-module--imageContainer--95cbf";
export var imageTextContainer = "productCard-module--imageTextContainer--a989d";
export var mobilePushHoverImg = "productCard-module--mobilePushHoverImg--d2320";
export var productCard = "productCard-module--productCard--df38c";
export var reviewsHoverImg = "productCard-module--reviewsHoverImg--2e28f";
export var smsMarketingHoverImg = "productCard-module--smsMarketingHoverImg--10d25";
export var styledButton = "productCard-module--styledButton--ed2bf";
export var subHeadline = "productCard-module--subHeadline--81d4b";
export var textContainer = "productCard-module--textContainer--10c60";